import React from 'react';

const TopMembersOfTheMonth = () => {
  return <div>TopMembersOfTheMonth</div>;
};

export default TopMembersOfTheMonth;
